var _style, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconAdmin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{fill:#B81F40;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame_-_24px"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 24,
    height: 24
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Filled_Icons"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 7,
    cy: 5,
    r: 3
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M7,8c-2.8,0-5,2.2-5,5v3c0,0.6,0.4,1,1,1h1v4c0,0.6,0.4,1,1,1h4c0.6,0,1-0.4,1-1v-4h1c0.6,0,1-0.4,1-1v-3 C12,10.2,9.8,8,7,8z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M24,7V5h-1.1c-0.1-0.6-0.4-1.2-0.7-1.8L23,2.5L21.5,1l-0.8,0.8c-0.5-0.3-1.1-0.6-1.8-0.7V0h-2v1.1 c-0.6,0.1-1.2,0.4-1.8,0.7L14.5,1l-1.4,1.4l0.8,0.8c-0.3,0.5-0.6,1.1-0.7,1.8H12v2h1.1c0.1,0.6,0.4,1.2,0.7,1.8l-0.8,0.8l1.4,1.4 l0.8-0.8c0.5,0.3,1.1,0.6,1.8,0.7V12h2v-1.1c0.6-0.1,1.2-0.4,1.8-0.7l0.8,0.8L23,9.5l-0.8-0.8c0.3-0.5,0.6-1.1,0.7-1.8H24z M18,8 c-1.1,0-2-0.9-2-2s0.9-2,2-2c1.1,0,2,0.9,2,2S19.1,8,18,8"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAdmin);
export default __webpack_public_path__ + "static/media/icon-admin.e265338a7d67cb180d208297e3dd187f.svg";
export { ForwardRef as ReactComponent };